var createPatternBuilder = require('./createPatternBuilder');
module.exports = generateIntegratorFunction;
module.exports.generateIntegratorFunctionBody = generateIntegratorFunctionBody;
function generateIntegratorFunction(dimension) {
  var code = generateIntegratorFunctionBody(dimension);
  return new Function('bodies', 'timeStep', 'adaptiveTimeStepWeight', code);
}
function generateIntegratorFunctionBody(dimension) {
  var pattern = createPatternBuilder(dimension);
  var code = "\n  var length = bodies.length;\n  if (length === 0) return 0;\n\n  ".concat(pattern('var d{var} = 0, t{var} = 0;', {
    indent: 2
  }), "\n\n  for (var i = 0; i < length; ++i) {\n    var body = bodies[i];\n    if (body.isPinned) continue;\n\n    if (adaptiveTimeStepWeight && body.springCount) {\n      timeStep = (adaptiveTimeStepWeight * body.springLength/body.springCount);\n    }\n\n    var coeff = timeStep / body.mass;\n\n    ").concat(pattern('body.velocity.{var} += coeff * body.force.{var};', {
    indent: 4
  }), "\n    ").concat(pattern('var v{var} = body.velocity.{var};', {
    indent: 4
  }), "\n    var v = Math.sqrt(").concat(pattern('v{var} * v{var}', {
    join: ' + '
  }), ");\n\n    if (v > 1) {\n      // We normalize it so that we move within timeStep range. \n      // for the case when v <= 1 - we let velocity to fade out.\n      ").concat(pattern('body.velocity.{var} = v{var} / v;', {
    indent: 6
  }), "\n    }\n\n    ").concat(pattern('d{var} = timeStep * body.velocity.{var};', {
    indent: 4
  }), "\n\n    ").concat(pattern('body.pos.{var} += d{var};', {
    indent: 4
  }), "\n\n    ").concat(pattern('t{var} += Math.abs(d{var});', {
    indent: 4
  }), "\n  }\n\n  return (").concat(pattern('t{var} * t{var}', {
    join: ' + '
  }), ")/length;\n");
  return code;
}